export enum BUTTON_TYPES {
	DEFAULT = 'default',
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
}
